import { ISimpleCommand } from "./ISimpleCommand";
import { ICommandReceiver } from "./ICommandReceiver";

/**
 * base class for all commands. your concrete command must inherit from this class. simply override execute function with your code.
 *
 * @author dkoehler
 */
export class SimpleCommand implements ISimpleCommand {
    private _executed: boolean = false;

    public get executed(): boolean {
        return this._executed;
    }

    public set executed(value: boolean) {
        this._executed = value;
    }

    private _singleExecution: boolean = false;

    public get singleExecution(): boolean {
        return this._singleExecution;
    }

    public set singleExecution(value: boolean) {
        this._singleExecution = value;
    }

    private _commandReceiver: ICommandReceiver[] = [];

    constructor(singleExecution: boolean = false) {
        this._singleExecution = singleExecution;
    }

    /** map with all registered command receiver for this command. */
    public get commandReceiver(): ICommandReceiver[] {
        return this._commandReceiver;
    }

    /**
     * execute command
     *
     * @param commandVars optional variables for this command
     *
     */
    public execute(commandVars: Object = null): void {
        // override
    }

    /**
     * add a receiver for this command
     *
     * @param clientReceiver receiver who will execute an action com command call
     *
     */
    public addReceiver(clientReceiver: ICommandReceiver): void {
        this._commandReceiver.push(clientReceiver);
    }

    /**
     * remove a receiver from this command
     *
     * @param clientReceiver receiver who should be removed
     *
     */
    public removeReceiver(clientReceiver: ICommandReceiver): void {
        for (let i: number = 0; i < this._commandReceiver.length; i++) {
            if (this._commandReceiver[i] == clientReceiver) {
                this._commandReceiver.splice(i, 1);
            }
        }
    }

    /**
     * remove all receiver from this command
     */
    public removeAllReceiver(): void {
        for (let i: number = 0; i < this._commandReceiver.length; i++) {
            this._commandReceiver[i] = null;
        }
    }
}
